import React from "react";
import { Reveal, useReveal } from "./_shared";

const DEFAULT_PILLARS = [
  { num: "I", label: "The Pulse", title: "Centuries in a Stitch", body: "A dialogue between the artisan's hand and the modern soul. Born in our Ahmedabad atelier." },
  { num: "II", label: "The Anatomy", title: "Bespoke Intent", body: "We do not design for the masses. We tailor for the individual. Measured to your unique geography." },
  { num: "III", label: "The Element", title: "Noble Flax", body: "Pure linen sourced for its cooling spirit. A living fabric that thrives in the sun and softens with time." },
  { num: "IV", label: "The Silence", title: "Substance Over Spectacle", body: "Stripping away the excess. No logos. No noise. Just the undeniable presence of the perfect silhouette." },
];

export default function PillarsSection({ eyebrow, heading, pillars }) {
  const gridRef = useReveal(0.15);
  const items = pillars || DEFAULT_PILLARS;
  return (
    <section
      className="bg-[#1A1A1A] text-[#c3ba9e] py-20 md:py-28 relative overflow-hidden"
      data-testid="heritage-strip"
    >
      <div
        className="hidden md:block absolute left-6 top-1/2 -translate-y-1/2 -rotate-90 origin-left text-[10px] tracking-[0.4em] uppercase text-[#c3ba9e]/35"
        aria-hidden="true"
      >
        MMXXVI · Edition 01
      </div>
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <Reveal className="text-center max-w-3xl mx-auto mb-16 md:mb-20">
          <p className="eyebrow shimmer-line text-[#c3ba9e]">
            {eyebrow ?? "A House Built Slowly"}
          </p>
          <h2 className="font-serif-display text-4xl md:text-6xl mt-6 leading-[1.05]">
            {heading ?? "Four tenets we never compromise on."}
          </h2>
        </Reveal>
        <div
          ref={gridRef}
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-px bg-[#c3ba9e]/15 border border-[#c3ba9e]/15 reveal-stagger"
        >
          {items.map((p) => (
            <div
              key={p.num}
              className="bg-[#1A1A1A] p-8 md:p-10 group cursor-default transition-colors duration-700 hover:bg-[#0c0c0c]"
            >
              <div className="flex items-baseline gap-4 mb-6">
                <span className="font-serif-display italic text-5xl md:text-6xl text-[#c3ba9e]/30 leading-none transition-colors duration-500 group-hover:text-[#c3ba9e]/55">
                  {p.num}
                </span>
                <span className="text-[10px] tracking-[0.32em] uppercase text-[#c3ba9e]/55">
                  {p.label}
                </span>
              </div>
              <h3 className="font-serif-display text-2xl md:text-[1.7rem] leading-[1.15] text-[#c3ba9e]">
                {p.title}
              </h3>
              <p className="text-[13.5px] text-[#c3ba9e]/65 leading-[1.7] mt-4">{p.body}</p>
              <span className="inline-block mt-6 h-px w-10 bg-[#c3ba9e]/40 transition-all duration-500 group-hover:w-20 group-hover:bg-[#c3ba9e]" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
